// Turns a failed PIN request into the reason the operator should see.
// apollo-link-rest puts the parsed error body on networkError.result; the
// Dashboard sends { code, message, errors: [{ field, code, message }] }, and
// the per-field messages ("Current PIN is incorrect", "PIN must be 6 digits")
// are the useful ones. ValidationError's top-level message is just
// "Validation Error", so it is skipped.
const STATUS_MESSAGES = {
  401: 'Authentication failed. Please login again.',
  403: 'Access denied.',
  404: 'Operator not found.',
};

const getBodyMessage = (body) => {
  if (!body || typeof body !== 'object') return null;
  const fieldError = (body.errors || []).find((err) => {
    return err && err.message;
  });
  if (fieldError) return fieldError.message;
  if (body.message && body.code !== 'ValidationError') return body.message;
  return null;
};

export const getPinErrorMessage = (err, fallback) => {
  const networkError = err && err.networkError;
  if (!networkError) {
    return (err && err.message) || fallback;
  }

  const bodyMessage = getBodyMessage(networkError.result);
  if (bodyMessage) return bodyMessage;

  const { statusCode } = networkError;
  if (!statusCode) return 'Network error. Please check your connection.';
  if (STATUS_MESSAGES[statusCode]) return STATUS_MESSAGES[statusCode];
  if (statusCode >= 500) return 'Server error. Please try again later.';
  return fallback;
};

// The Dashboard's set-pin rejections about the current PIN ("Current PIN is
// incorrect", "Current PIN is required to change PIN"). Retrying with the same
// stored PIN can't succeed, so the operator has to verify again.
export const isCurrentPinError = (message) => {
  return typeof message === 'string' && message.startsWith('Current PIN');
};

export default getPinErrorMessage;
